import _createClass from "@babel/runtime/helpers/esm/createClass";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { enableIndexedDbPersistence, getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
const VAPID_KEY = "BIdwxmrN-bVxZatNfT_StVYPY7WNLwuYWdlI8XNvgWzE6n9Keb5qnXhuEpQQoSDYVxuidw82ytklNMpE59IzKeE";
// Do NOT call any of these methods before mount. Otherwise gatsby build will fail
// i.e. only call it in useEffect and the render method
let FirebaseHandler = /*#__PURE__*/ function () {
    function FirebaseHandler() { }
    FirebaseHandler.initialize = function initialize() {
        if (!this._app) {
            this._app = initializeApp({
                apiKey: "AIzaSyCgxi0sp8s2xusies7MT-n1g-lO8GdFnus",
                authDomain: "makroskop-b14f3.firebaseapp.com",
                databaseURL: "https://makroskop-b14f3.firebaseio.com",
                projectId: "makroskop-b14f3",
                storageBucket: "makroskop-b14f3.appspot.com",
                //messagingSenderId: "665726034694",
                appId: "1:665726034694:web:6d691d4173f4503a76f487"
            });
            this._auth = getAuth(this._app);
            this._firestore = getFirestore(this._app);
            this._functions = getFunctions(this._app, "europe-west1");
            // this._messaging = getMessaging(this._app)
            this._storage = getStorage(this._app);
            // Firebase Push News initialization
            /*
            this._messaging.usePublicVapidKey(VAPID_KEY)
            this._messaging.onMessage((payload) => {
              // TODO Add icon
              const notification = new Notification(payload.notification.title, { body: payload.notification.body })
            })
             this._messaging.onTokenRefresh(() => {
              this._messaging
                .getToken()
                .then((token) => subscribeToGeneral(token))
                .catch((err) => console.error("Failed to get Token: ", err))
            })
            */
            // Firestore enable offline mode
            enableIndexedDbPersistence(this._firestore).catch(err => console.warn(err));
        }
    };
    return _createClass(FirebaseHandler, null, [{
            key: "app",
            get: function () {
                this.initialize();
                return this._app;
            }
        }, {
            key: "auth",
            get: function () {
                this.initialize();
                return this._auth;
            }
        }, {
            key: "firestore",
            get: function () {
                this.initialize();
                return this._firestore;
            }
        }, {
            key: "functions",
            get: function () {
                this.initialize();
                // useFunctionsEmulator(this._functions, "localhost", 5001)
                return this._functions;
            }
            /*
            static get messaging(): FirebaseMessaging {
              this.initialize()
              return this._messaging
            }
            */
        }, {
            key: "storage",
            get: function () {
                this.initialize();
                return this._storage;
            }
        }]);
}();
export default FirebaseHandler;
